const { useState, useCallback } = require("react")

const useToggle = (initial) => {

    const [open, setOpen] = useState(initial || false)

    const toggle = useCallback(() => {
        setOpen(!open)
    }, [open])

    return [open, setOpen, toggle]
}

export default useToggle